import { Link } from "react-router-dom"
import ContentLayout from "../../layout/contentLayout";
import styles from './scss/emailcampaign.module.scss';
import { assets } from "../../styles/assets/assets";
import WorktualDropdown from "../../components/custom_components/WroktualDropdown";

const EmailCampaign = () => {
    const options = [
        {
            label: 'One', value: 'one'
        }
    ]
    return (
        <ContentLayout noPaddingBlock={true}>
            <div className='breadcrumbs'>
                <ol>
                    <li>
                        <Link to=''>Campaign Name</Link>
                    </li>
                    <li>Email </li>
                </ol>
            </div>
            <div className={styles.emailsec}>
                <div className={styles.mdflefts}>
                    <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                    <div className={styles.searchset}>
                        <input type="text" name="" id="" placeholder='Ask to edit' />
                        <img className={styles.searchlt} src={assets.search_icon} alt="search_icon" />
                        <img className={styles.closeic} src={assets.multi_close} alt="multi_close" />
                    </div>
                </div>
                <div className={styles.mdfrights}>
                    <div className={styles.headertxtgrp}>
                        <div className={styles.headerlefts}>
                            <p>A/B Test:</p>
                            <div className={styles.dropmenu}>
                                <WorktualDropdown onChange={() => { }} options={options}>
                                    <button className='cancelbtn'>Type A <img src={assets.chevrondown_icon} alt="chevrondown_icon" /></button>
                                </WorktualDropdown>
                            </div>
                        </div>
                        <div className={styles.headerrights}>

                            <img className={styles.fullscr} src={assets.fullscreen_icon} alt="fullscreen_icon" />
                        </div>
                    </div>
                    <div className={styles.prevsec}>
                       
                    </div>
                     <div className={styles.btnsec}>
                            <button className='cancelbtn'>Cancel</button>
                            <button className='primarybtn'>Publish</button>
                        </div>
                </div>
            </div>
        </ContentLayout>
    )
}

export default EmailCampaign
